import { evaluateCanOptimistic } from "@/permissions/v2/can";
import { usePermissionsV2Store } from "@/store/permissionsV2Store";

export const useCanMarkCaseReviewed = (firmId?: string): boolean =>
  usePermissionsV2Store((s) =>
    s.isLoaded && firmId
      ? evaluateCanOptimistic(s.permissions, "cases", "update:mark_reviewed", { firm_id: firmId })
      : false
  );

export const useCanCreateCase = (firmId?: string): boolean =>
  usePermissionsV2Store((s) =>
    s.isLoaded && firmId
      ? evaluateCanOptimistic(s.permissions, "cases", "create", { firm_id: firmId })
      : false
  );

export const useCanRequestChronologyRun = (firmId?: string): boolean =>
  usePermissionsV2Store((s) =>
    s.isLoaded && firmId
      ? evaluateCanOptimistic(s.permissions, "cases", "update:request_med_chron", {
          firm_id: firmId,
        })
      : false
  );

// The underlying version data (getVisits/getSummary by version_id) isn't restricted server-side,
// so this only hides the "Compare versions" menu item from non-Super Admins.
export const useCanCompareVersions = (firmId?: string): boolean =>
  usePermissionsV2Store((s) =>
    s.isLoaded && firmId
      ? evaluateCanOptimistic(s.permissions, "medchron", "compare_versions", { firm_id: firmId })
      : false
  );
